import  React, {useEffect} from "react";
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {
    Typography,
    IconButton,
    Icon,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Button
} from "@mui/material";

import DefinitionSection from "~common/form/definition-section-fc";
import {cloneDeep} from 'lodash'
import * as request from "superagent";
import LoadingView from "~common/components/loading-view";
import PresentSave from '~common/form/sequence-editor-present-save';
import InstrtuctionsView from "~common/form/form-based-container-instructions-fc"

import {DataContext} from "~common/form/icg-definition-data-provider";
import {PolicyContext} from "~common/form/icg-definition-data-provider";
import {ActiveSectionContext} from "~common/form/form-based-container-fc";
import {DirtyContext} from "~common/form/icg-definition-data-provider";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    section: {
        minHeight: 700
    },
    templateSection: {
        padding: 5
    },
    sectionTitle: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
    },
    controls: {
        height: 50,
        paddingTop: 10,
        position: "fixed",
        bottom: 0,
        right: 0,
        left: 0
    },
    backButton: {
        position: "fixed",
        bottom: 10,
        left: 25,
        width: 175,
    },
    continueButton: {
        position: "fixed",
        float: "right",
        width: 175,
        bottom: 10,
        right: 25
    },
    sequenceinstructionContainer: {
		marginBottom: 15,
        marginTop: 5
	},
  })
);

interface DefinitionSequenceProps {
    formDefinition: any;
    readOnly?: boolean;
    submitAction?: boolean;
    suppressedSections?: any;
    suppressedSectionsFn?: any;
    introTemplate?: any;
    summaryTemplate?: any;
    readOnlySections?: any;
    match: any;
    task?: any;
    history: any;
    setError?: any;
    setSuppressWarnings?: any;
    suppressWarnings?: any;
    suppressSubmit?: boolean;
    handleAction?: any;
    showSequenceInstructions?: boolean;
}

export const DefinitionSequence: React.FC<DefinitionSequenceProps> = ({
    formDefinition,
    readOnly,
    submitAction,
    suppressedSections,
    suppressedSectionsFn,
    introTemplate,
    summaryTemplate,
    readOnlySections,
    match,
    task,
    history,
    setError,
    showSequenceInstructions,
    setSuppressWarnings,
    suppressWarnings,
    suppressSubmit,
    handleAction,
    onHistoryViewToggle
}) => {
    const classes = useStyles();    

    const [fullData, setFullData] = useContext(DataContext);
    const [policyMessages, setPolicyMessages] = useContext(PolicyContext);
    const [activeSection, setActiveSection] = useContext(ActiveSectionContext)
    const [formDirty, setFormDirty] = useContext(DirtyContext);

    const [status, setStatus] = useState("loading")
    const [saving, setSaving] = useState(undefined)
    const [sections, setSections] = useState(Array<any>())
    const [introTemplateCompiled, setIntroTemplateCompiled] = useState(undefined)
    const [summaryTemplateCompiled, setSummaryTemplateCompiled] = useState(undefined)
    const [definition, setDefinition] = useState(undefined)
    const [targetSection, setTargetSection] = useState(undefined)
    const [presentSave, setPresentSave] = useState(undefined)
    const [navigationMenuAnchorEl, setNavigationMenuAnchorEl] = useState(undefined)
    const [showNavigationMenu, setShowNavigationMenu] = useState(undefined)

    const getSectionIndex = (key: string) => {
        var idx = sections.findIndex((s: any) => { return s.key == key })
        return idx
    }

    const getSection = (key: string) => {
        var idx = getSectionIndex(key)
        return sections[idx]
    }

    const getSectionKey = (index: number) => {
        var section = sections[index]
        return section.key
    }

    const handleNavigationMenuClick = (e: any) => {
        setNavigationMenuAnchorEl(e.target)
        setShowNavigationMenu(!showNavigationMenu)
    };

    const handleNavigationMenuClose = (e: any) => {
        setShowNavigationMenu(false)
    };

    const sectionIsComplete = (key: string) => {
        var {status} = fullData
        if (status && status.sections && status.sections[key] && status.sections[key].complete) {
            return true
        }
        return false
    }

    const previousSection = () => {
        var nextSectionIDX = getSectionIndex(activeSection) - 1
        var nextSection = sections[nextSectionIDX]
        return nextSection
    }

    const nextSection = () => {
        var nextSectionIDX = getSectionIndex(activeSection) + 1
        var nextSection = sections[nextSectionIDX]
        return nextSection
    }

    const handleBack = () => {
        if (status == "ready") {
            if (sectionIsDirty() && !readOnly) {

                var ps = previousSection()
                setTargetSection(ps)
                setPresentSave(true)
    
            } else {
            
                var ps = previousSection()
                setActiveSection(ps.key)
            }
        }
    }

    const handleContinue = () => {
        if (sectionIsDirty() && !readOnly) {

            task.taskData[formDefinition.key] = fullData

            var sectionURL = `/api${window.location.pathname}`

            if (status == "ready") {
                
                setSaving(true)

                request.put(sectionURL).send(task).then((response: request.Response) => {

                    if (response.body.policyMessages && response.body.policyMessages.length > 0) {

                        // reconcile messages
                        let newMessages = response.body.policyMessages
                        if (policyMessages) {
                            for (let policyMessage of policyMessages) {
                                if (policyMessage.path) {
                                    if (!policyMessage.path.startsWith("/"+activeSection)) {
                                        newMessages.push(policyMessage);
                                    }
                                }
                            }
                            
                        } 
                        
                        let hasWarning = false;
                        for (let pm of newMessages) {
                            if (pm.severity == 1) {
                                hasWarning = true;
                            }
                        }

                        var _fullData = cloneDeep(response.body.data || fullData)

                        setFullData(_fullData)
                        setPolicyMessages(newMessages)
                        setError("Validation errors exist")
                        setSuppressWarnings(hasWarning)
                        setSaving(false)
                     
                    } else {
                            
                        var _sections = cloneDeep(sections)

                        _sections.forEach((s: any) => {
                            if (s.key == activeSection) {
                                s.dirty = false
                            }
                        })
    
                        let messages = policyMessages || []
                        let finalMessages = []

                        for (let message of messages) {
                            if (message.path && !message.path.startsWith("/"+activeSection)) {
                                finalMessages.push(message);
                            }
                        }
                        let hasWarning = false;
                        for (let pm of finalMessages) {
                            if (pm.severity == 1) {
                                hasWarning = true;
                            }
                        }
    
                        var _fullData = cloneDeep(response.body.data || fullData)

                        setSections(_sections)
                        setFullData(_fullData)
                        setPolicyMessages(finalMessages)
                        setActiveSection(nextSection().key)
                        setSuppressWarnings(hasWarning)
                        setFormDirty(false)
                        setSaving(false)
                    }
    
                }).catch((err) => {
                    setSaving(false)
                    setError(err)
                })
            }
    
        } else {
            var ns = nextSection()
            setActiveSection(ns.key)
        }
    }

    const renderSection = () => {
        var section = sections.find((s:any)=>{return s.key == activeSection})
        if (section) {
            if (section.intro || section.summary) {

                if (section.intro) {
                    var content = introTemplateCompiled
                } else {
                    var content = summaryTemplateCompiled
                }

                return <div className={classes.templateSection} dangerouslySetInnerHTML={{ __html: content }}></div>

            } else {

                var sectionKey = match.params.section

                var sectionIDX = definition.definitions.findIndex((s: any) => { return s.key == sectionKey })

                var sectionReadOnly = readOnly
                if (readOnlySections && readOnlySections.indexOf(sectionKey) > -1) {
                    sectionReadOnly = true
                }

                return <DefinitionSection
                    definition={definition}
                    path={''}
                    policyMessages={policyMessages}
                    gridSpacing={4}
                    embedded={true}
                    sectionIDX={sectionIDX}
                    readOnly={sectionReadOnly}
                    onHistoryViewToggle={onHistoryViewToggle}
                />
            }
        }
        return undefined
    }

    const renderNavigation = () => {
        var sectionIndex = sections.findIndex((s:any)=>{return s.key == activeSection})
        return (
            <div>
                <Typography className={classes.sectionTitle} variant="h4">
                    {sections.length > 0 && <span>{sections[sectionIndex].title + ' (' + (sectionIndex + 1) + ' of ' + sections.length + ')'}</span>}
                    <IconButton
                        size="large"
                        className={classes.menuButton + " " + "section-navigate-menu-button"}
                        aria-owns={showNavigationMenu ? 'section-menu' : undefined}
                        aria-haspopup="true"
                        onClick={handleNavigationMenuClick}
                    >
                        <Icon>keyboard_arrow_down</Icon>
                    </IconButton>
                </Typography>
                <Menu
                    id="section-menu"
                    anchorEl={navigationMenuAnchorEl}
                    open={showNavigationMenu || false}
                    onClose={handleNavigationMenuClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                    {sections.map((s, idx) => {
                        let icon = <Icon color="primary">check_box_outline_blank</Icon>;
                        if (sectionIsComplete(s.key)) {
                            icon = <Icon style={{color: "green"}} color="primary">check_box_icon</Icon>;
                        }
                        return (
                            <MenuItem className={activeSection == idx ? classes.selected: ''} key={idx} onClick={handleNavigate.bind(this, s.key)}>
                                <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
                                <ListItemText className={classes.text} inset primary={s.title} />
                            </MenuItem>
                        );
                    })}
                </Menu>
            </div>
        )
    }

    const buildContinue = () => {
        if (readOnly || !sectionIsDirty()) {
            return "Continue"
        } else if (sectionIsDirty()) {
            return "Save & Continue"
        }
    }

    const renderControls = () => {
        // If there is 0 or 1 sections you dont need to navigate
        if (sections && sections.length > 1) {
            var activeSectionIndex = getSectionIndex(activeSection)
            return (
                <Paper className={classes.controls}>
                     {activeSectionIndex > 0 && 
                        <Button
                            className={classes.backButton}
                            variant="contained"
                            color="inherit"
                            onClick={handleBack}
                            >
                            {'Back'}
                        </Button>
                    }
    
                    {activeSectionIndex != (sections.length - 1) && 
                        <Button
                            className={classes.continueButton}
                            variant="contained"
                            color="primary"
                            onClick={handleContinue}
                            >
                            {buildContinue()}
                        </Button>
                    }

                    {!suppressSubmit && !readOnly && submitAction && activeSectionIndex == (sections.length - 1) && <Button
                        className={classes.continueButton}
                        variant="contained"
                        color="primary"
                        onClick={handleAction.bind(this, submitAction)}
                        >
                        Submit
                    </Button>}
    
                </Paper>
            )
        }
    }

    const goToSection = () => {

        var section = sections.find((s:any)=>{return s.key == activeSection})

        if (section) {
            if (section.intro || section.summary) {

                var _section = section
                var data = cloneDeep(fullData)
                var template
                if (section.intro) {
                    template = introTemplate
                }
                if (section.summary) {
                    template = summaryTemplate
                }
    
    
                // set id to be used in template
                data._id = match.params.id
                // set form to be used in template
                data._form = definition
                if (task) {
                    data._task = task
                    data._taskType = task.taskType
                }
    
                if (policyMessages) {
                    data._policyMessages = policyMessages
                }
    
                if (suppressWarnings) {
                    data._suppressWarnings = suppressWarnings
                }
                
                setStatus("loading")

                request.put(`/api/portal-templates/compile`).send({ template: template.templateContents, data: data }).then((response: request.Response) => {
    
                    var _introTemplateCompiled, _summaryTemplateCompiled
                    if (_section.intro) {
                        _introTemplateCompiled = response.body.compiled
                    }
    
                    if (_section.summary) {
                        _summaryTemplateCompiled = response.body.compiled
                    }
    
                    setIntroTemplateCompiled(_introTemplateCompiled)
                    setSummaryTemplateCompiled(_summaryTemplateCompiled)
                    setTargetSection(undefined)
                    setPresentSave(false)
    
                    var url = window.location.pathname
                    var parts = url.split("/")
                    var _sec = parts[parts.length - 1]
                    url = url.replace(_sec, section.key)
                    history.push(url + window.location.search)

                    setStatus("ready")
    
                }).catch((err) => {
                    setError(err)
                })
            } else {
    
                setTargetSection(undefined)
                setPresentSave(false)
    
                var url = window.location.pathname
                var parts = url.split("/")
                var _sec = parts[parts.length - 1]
                url = url.replace(_sec, section.key)
                history.push(url + window.location.search)

                setStatus("ready")
            }
        }
    }

    const jumpToSection = (section:string) => {
        const keys:Array<any> = section.split("/");

        window.history.pushState('','',section + window.location.search)

        setActiveSection(keys[keys.length - 1])
    }

    const handleNavigate = (key: any) => {
        setNavigationMenuAnchorEl(undefined)
        setShowNavigationMenu(false)
        if (sectionIsDirty() && !readOnly) {

            var section = getSection(key)
            
            setTargetSection(section)
            setPresentSave(true)

        } else {
            setActiveSection(key)
        }
    }

    const sectionIsDirty = () => {
        var section = getSection(activeSection)
        return section.dirty
    }

    const saveSection = () => {
        
        task.taskData[formDefinition.key] = fullData

        var sectionURL = `/api${window.location.pathname}`

        setPresentSave(false)
        setSaving(true)
        request.put(sectionURL + "?skipValidations=true").send(task).then((response: request.Response) => {

            var _sections = cloneDeep(sections)

            _sections.forEach((s: any) => {
                if (s.key == activeSection) {
                    s.dirty = false
                }
            })

            let messages = cloneDeep(policyMessages || [])

            let newMessages = response.body["policyMessages"]
            if (newMessages) {
                for (let newMessage of newMessages) {
                    let duplicate = false
                    for (let message of messages) {
                        if (message.message == newMessage.message && message.path == newMessage.path) {
                            duplicate = true
                        }
                    }
                    if (duplicate != true) {
                        messages.push(newMessage);
                    }
                }
            }

            let hasWarning = false;
            for (let pm of messages) {
              if (pm.severity == 1) {
                hasWarning = true;
              }
            }



            var _fullData = cloneDeep(response.body.data || fullData)

            setSections(_sections)
            setFullData(_fullData)
            setPolicyMessages(messages)
            setPresentSave(false)
            setSuppressWarnings(hasWarning)
            if (targetSection) {
                setActiveSection(targetSection.key)
            }
            setFormDirty(false)
            setSaving(false)

        }).catch((err) => {
            setSaving(false)
            setError(err)
        })
    }

    const handleSaveModalClose = () => {
        setPresentSave(false)
    }

    const goTargetSection = (revertCurrentSection?: boolean) => {
        
        var sectionURL = `/api${window.location.pathname}`
        
        if (revertCurrentSection) {

            setPresentSave(false)
            setStatus("loading")
            request.get(sectionURL).then((response: request.Response) => {

                var _fullData = cloneDeep(fullData)

                _fullData[activeSection] = response.body.data

                var _sections = cloneDeep(sections)

                _sections.forEach((s:any)=>{
                    if (s.key == activeSection) {
                        s.dirty = false
                    }
                })

                setFullData(_fullData)

                setSections(_sections)                
                setActiveSection(targetSection.key)
                setFormDirty(false)
                setStatus("ready")
        
            }).catch((err) => {
                setError(err)
            })
        } else {
            setActiveSection(targetSection.key)
        }
    }

    useEffect(() => {
        var _sections = Array<any>();

        // build sections from definitions
        _sections = formDefinition.definitions.map((s: any) => { return { key: s.key, title: s.title } })

        var _definition = cloneDeep(formDefinition)

        if (suppressedSectionsFn) {
            var suppressFuncResults = suppressedSectionsFn(fullData)
            if (suppressFuncResults && suppressFuncResults.length > 0){
                suppressedSections = suppressedSections.concat(suppressFuncResults)
            }
        }

        // filter suppressed sections from definition
        if (suppressedSections && suppressedSections.length > 0) {

            var definitions:Array<any> = [];

            _definition.definitions.forEach((d:any)=>{
                if (suppressedSections.indexOf(d.key) == -1) {
                    definitions.push(d)
                }
            })

            _definition.definitions = definitions
        }

        // filter out sections that are suppressed for navigation/status
        if (suppressedSections && suppressedSections.length > 0) {
            _sections = _sections.filter((s: any) => {
                if (suppressedSections.indexOf(s.key) > -1) {
                    return false
                }
                return true
            })
        }

         // intro first step
         if (introTemplate) {
            _sections.unshift({ intro: true, key: "intro", title: introTemplate.title })
        }

        // summary last step
        if (summaryTemplate) {
            _sections.push({ summary: true, key: "summary", title: summaryTemplate.title })
        }

        setDefinition(_definition)
        setSections(_sections)

        setActiveSection(match.params.section)
    }, [])

    useEffect(() => {
        (window as any)._jumpToSection = jumpToSection
        goToSection()
    }, [activeSection])

    useEffect(() => {
        var _sections = cloneDeep(sections)
        if (_sections && _sections.length > 0) {
            _sections.forEach((s: any) => {
                if (s.key == activeSection) {
                    s.dirty = formDirty
                }
            })
            setSections(_sections)
        }
    }, [formDirty])

    var section, navigation, controls


    if (activeSection !== undefined) {
        section = renderSection()

        navigation = renderNavigation()

        controls = renderControls()
    }

    var presentSaveModal
    if (presentSave) {
        presentSaveModal = <PresentSave targetSection={targetSection} handleYes={saveSection} handleNo={goTargetSection.bind(this, true)} handleClose={handleSaveModalClose} />
    }

    return (
        <div>

        <div className={classes.section}>
            {navigation}
            {presentSaveModal}
            {status == "loading" && <LoadingView classes={{}} />}
            {saving && <LoadingView text={" "} overlay={true} classes={{}} />}
            {task && showSequenceInstructions &&  <div className={classes.sequenceinstructionContainer}>
                <Typography style={{textIndent: 20}} dangerouslySetInnerHTML={{ __html: task.instructions}} />
            </div>}
            
            {status == "ready" && section}
            {controls}
        </div>
        </div>
    );
};

export default DefinitionSequence;